import classNames from 'classnames/bind';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import MiniTable from './MiniTable';
import styles from './Vibration.module.scss';

const cx = classNames.bind(styles);

const Vibration = ({ data: robotId }) => {
  const vibration = useSelector((state) => state.telemetry[robotId]?.vibration);

  const values = useMemo(() => {
    return {
      vibrationX: vibration?.vibrationX ?? 0,
      vibrationY: vibration?.vibrationY ?? 0,
      vibrationZ: vibration?.vibrationZ ?? 0,
      clipping0: vibration?.clipping0 ?? 0,
      clipping1: vibration?.clipping1 ?? 0,
      clipping2: vibration?.clipping2 ?? 0,
    };
  }, [vibration]);

  return (
    <div className={cx('container')}>
      <div className={cx('gauges')}>
        <div className={cx('item')}>
          <div className={cx('gauge')}>
            <div className={cx('bar')} style={{ height: `${values.vibrationX}%` }} />
            <div className={cx(['caution', 'v30'])} />
            <div className={cx(['caution', 'v60'])} />
            <div className={cx('value')}>{values.vibrationX.toFixed(2)}</div>
          </div>
          <div className={cx('label')}>X</div>
        </div>
        <div className={cx('item')}>
          <div className={cx('gauge')}>
            <div className={cx('bar')} style={{ height: `${values.vibrationY}%` }} />
            <div className={cx(['caution', 'v30'])} />
            <div className={cx(['caution', 'v60'])} />
            <div className={cx('value')}>{values.vibrationY.toFixed(2)}</div>
          </div>
          <div className={cx('label')}>Y</div>
        </div>
        <div className={cx('item')}>
          <div className={cx('gauge')}>
            <div className={cx('bar')} style={{ height: `${values.vibrationZ}%` }} />
            <div className={cx(['caution', 'v30'])} />
            <div className={cx(['caution', 'v60'])} />
            <div className={cx('value')}>{values.vibrationZ.toFixed(2)}</div>
          </div>
          <div className={cx('label')}>Z</div>
        </div>
      </div>
      <MiniTable
        title="Clipping"
        data={[
          { label: 'Primary', value: values.clipping0 },
          { label: 'Secondary', value: values.clipping1 },
          { label: 'Tertiary', value: values.clipping2 },
        ]}
      />
    </div>
  );
};

export default Vibration;
